// removed by extract-text-webpack-plugin
module.exports = {"end-date-container":"date-range__end-date-container___329Mi","start-date-container":"date-range__start-date-container___23Gfe","financial-year":"date-range__financial-year___39iyt"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/date-range.scss
// module id = 1303
// module chunks = 0